import { render, staticRenderFns } from "./PosItem.vue?vue&type=template&id=f02a1266&"
import script from "./PosItem.vue?vue&type=script&lang=js&"
export * from "./PosItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports